import { IDesignStudio } from '@/components/organisms/or-design-studio-block/or-design-studio-block.types';

export const mlStudioListMockData = [];

export const mockStudios = [
  {
    Address: '779 White Pond Drive',
    City: 'Akron',
    Id: 1,
    Name: 'Akron-Canton',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 437,
            Name: 'Carroll',
            IsPreferred: true,
          },
          {
            Id: 438,
            Name: 'Cuyahoga',
            IsPreferred: true,
          },
          {
            Id: 442,
            Name: 'Lorain',
            IsPreferred: true,
          },
          {
            Id: 443,
            Name: 'Medina',
            IsPreferred: true,
          },
          {
            Id: 446,
            Name: 'Stark',
            IsPreferred: true,
          },
          {
            Id: 447,
            Name: 'Summit',
            IsPreferred: true,
          },
          {
            Id: 448,
            Name: 'Tuscarawas',
            IsPreferred: true,
          },
        ],
        Id: 36,
        Name: 'OH',
      },
    ],
    Zip: '44320',
  },
  {
    Address: '4367 State Route 14',
    City: 'Ravenna',
    Id: 3,
    Name: 'Ravenna',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 218,
            Name: 'Beaver',
            IsPreferred: true,
          },
          {
            Id: 219,
            Name: 'Butler',
            IsPreferred: false,
          },
          {
            Id: 220,
            Name: 'Clarion',
            IsPreferred: true,
          },
          {
            Id: 221,
            Name: 'Crawford',
            IsPreferred: true,
          },
          {
            Id: 224,
            Name: 'Erie',
            IsPreferred: true,
          },
          {
            Id: 226,
            Name: 'Lawrence',
            IsPreferred: true,
          },
          {
            Id: 227,
            Name: 'Mercer',
            IsPreferred: true,
          },
          {
            Id: 228,
            Name: 'Venango',
            IsPreferred: true,
          },
        ],
        Id: 19,
        Name: 'PA',
      },
      {
        Counties: [
          {
            Id: 230,
            Name: 'Ashtabula',
            IsPreferred: true,
          },
          {
            Id: 231,
            Name: 'Columbiana',
            IsPreferred: true,
          },
          {
            Id: 232,
            Name: 'Geauga',
            IsPreferred: true,
          },
          {
            Id: 233,
            Name: 'Lake',
            IsPreferred: true,
          },
          {
            Id: 234,
            Name: 'Mahoning',
            IsPreferred: true,
          },
          {
            Id: 235,
            Name: 'Portage',
            IsPreferred: true,
          },
          {
            Id: 236,
            Name: 'Trumbull',
            IsPreferred: true,
          },
        ],
        Id: 20,
        Name: 'OH',
      },
    ],
    Zip: '44266',
  },
  {
    Address: '5087 Columbus PK',
    City: 'Lewis Center',
    Id: 4,
    Name: 'Columbus',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 17,
            Name: 'Champaign',
            IsPreferred: false,
          },
          {
            Id: 19,
            Name: 'Delaware',
            IsPreferred: true,
          },
          {
            Id: 20,
            Name: 'Franklin',
            IsPreferred: true,
          },
          {
            Id: 21,
            Name: 'Licking',
            IsPreferred: true,
          },
          {
            Id: 22,
            Name: 'Logan',
            IsPreferred: false,
          },
          {
            Id: 23,
            Name: 'Madison',
            IsPreferred: true,
          },
          {
            Id: 24,
            Name: 'Marion',
            IsPreferred: true,
          },
          {
            Id: 26,
            Name: 'Morrow',
            IsPreferred: false,
          },
          {
            Id: 27,
            Name: 'Muskingum',
            IsPreferred: true,
          },
          {
            Id: 29,
            Name: 'Union',
            IsPreferred: false,
          },
        ],
        Id: 3,
        Name: 'OH',
      },
    ],
    Zip: '43035',
  },
  {
    Address: '811 Chamber Dr.',
    City: 'Milford',
    Id: 5,
    Name: 'Cincinnati',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 181,
            Name: 'Dearborn',
            IsPreferred: true,
          },
          {
            Id: 185,
            Name: 'Franklin',
            IsPreferred: true,
          },
          {
            Id: 186,
            Name: 'Ohio',
            IsPreferred: true,
          },
        ],
        Id: 17,
        Name: 'IN',
      },
      {
        Counties: [
          {
            Id: 306,
            Name: 'Adams',
            IsPreferred: true,
          },
          {
            Id: 307,
            Name: 'Brown',
            IsPreferred: true,
          },
          {
            Id: 308,
            Name: 'Butler',
            IsPreferred: true,
          },
          {
            Id: 309,
            Name: 'Clermont',
            IsPreferred: true,
          },
          {
            Id: 310,
            Name: 'Clinton',
            IsPreferred: true,
          },
          {
            Id: 312,
            Name: 'Hamilton',
            IsPreferred: true,
          },
          {
            Id: 313,
            Name: 'Highland',
            IsPreferred: true,
          },
          {
            Id: 314,
            Name: 'Montgomery',
            IsPreferred: false,
          },
          {
            Id: 316,
            Name: 'Warren',
            IsPreferred: true,
          },
          {
            Id: 743,
            Name: 'Greene',
            IsPreferred: false,
          },
        ],
        Id: 26,
        Name: 'OH',
      },
      {
        Counties: [
          {
            Id: 473,
            Name: 'Boone',
            IsPreferred: true,
          },
          {
            Id: 474,
            Name: 'Bracken',
            IsPreferred: true,
          },
          {
            Id: 475,
            Name: 'Campbell',
            IsPreferred: true,
          },
          {
            Id: 490,
            Name: 'Fleming',
            IsPreferred: true,
          },
          {
            Id: 491,
            Name: 'Grant',
            IsPreferred: true,
          },
          {
            Id: 492,
            Name: 'Kenton',
            IsPreferred: true,
          },
          {
            Id: 493,
            Name: 'Mason',
            IsPreferred: true,
          },
          {
            Id: 494,
            Name: 'Pendleton',
            IsPreferred: true,
          },
        ],
        Id: 39,
        Name: 'KY',
      },
    ],
    Zip: '45150',
  },
  {
    Address: '6539 South Dixie Highway',
    City: 'Cygnet',
    Id: 6,
    Name: 'Bowling Green',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 418,
            Name: 'Allen',
            IsPreferred: true,
          },
          {
            Id: 419,
            Name: 'Auglaize',
            IsPreferred: false,
          },
          {
            Id: 420,
            Name: 'Defiance',
            IsPreferred: true,
          },
          {
            Id: 421,
            Name: 'Fulton',
            IsPreferred: true,
          },
          {
            Id: 422,
            Name: 'Hancock',
            IsPreferred: true,
          },
          {
            Id: 423,
            Name: 'Hardin',
            IsPreferred: true,
          },
          {
            Id: 424,
            Name: 'Henry',
            IsPreferred: true,
          },
          {
            Id: 425,
            Name: 'Lucas',
            IsPreferred: true,
          },
          {
            Id: 427,
            Name: 'Ottawa',
            IsPreferred: true,
          },
          {
            Id: 428,
            Name: 'Paulding',
            IsPreferred: true,
          },
          {
            Id: 429,
            Name: 'Putnam',
            IsPreferred: true,
          },
          {
            Id: 430,
            Name: 'Sandusky',
            IsPreferred: true,
          },
          {
            Id: 431,
            Name: 'Seneca',
            IsPreferred: true,
          },
          {
            Id: 432,
            Name: 'Van Wert',
            IsPreferred: true,
          },
          {
            Id: 433,
            Name: 'Williams',
            IsPreferred: true,
          },
          {
            Id: 434,
            Name: 'Wood',
            IsPreferred: true,
          },
          {
            Id: 435,
            Name: 'Wyandot',
            IsPreferred: true,
          },
        ],
        Id: 35,
        Name: 'OH',
      },
    ],
    Zip: '43413',
  },
  {
    Address: '1895 Township Road 405',
    City: 'Jeromesville',
    Id: 7,
    Name: 'Ashland',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 129,
            Name: 'Ashland',
            IsPreferred: true,
          },
          {
            Id: 130,
            Name: 'Coshocton',
            IsPreferred: true,
          },
          {
            Id: 131,
            Name: 'Crawford',
            IsPreferred: true,
          },
          {
            Id: 132,
            Name: 'Erie',
            IsPreferred: true,
          },
          {
            Id: 133,
            Name: 'Holmes',
            IsPreferred: true,
          },
          {
            Id: 134,
            Name: 'Huron',
            IsPreferred: true,
          },
          {
            Id: 135,
            Name: 'Knox',
            IsPreferred: true,
          },
          {
            Id: 138,
            Name: 'Morrow',
            IsPreferred: true,
          },
          {
            Id: 139,
            Name: 'Richland',
            IsPreferred: true,
          },
          {
            Id: 140,
            Name: 'Wayne',
            IsPreferred: true,
          },
        ],
        Id: 14,
        Name: 'OH',
      },
    ],
    Zip: '44840',
  },
  {
    Address: '11272 US Rt 23',
    City: 'Lockbourne',
    Id: 8,
    Name: 'Circleville',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 237,
            Name: 'Athens',
            IsPreferred: true,
          },
          {
            Id: 239,
            Name: 'Fairfield',
            IsPreferred: true,
          },
          {
            Id: 240,
            Name: 'Fayette',
            IsPreferred: true,
          },
          {
            Id: 241,
            Name: 'Franklin',
            IsPreferred: false,
          },
          {
            Id: 242,
            Name: 'Gallia',
            IsPreferred: true,
          },
          {
            Id: 244,
            Name: 'Hocking',
            IsPreferred: true,
          },
          {
            Id: 245,
            Name: 'Jackson',
            IsPreferred: true,
          },
          {
            Id: 246,
            Name: 'Lawrence',
            IsPreferred: true,
          },
          {
            Id: 247,
            Name: 'Madison',
            IsPreferred: false,
          },
          {
            Id: 248,
            Name: 'Meigs',
            IsPreferred: true,
          },
          {
            Id: 249,
            Name: 'Morgan',
            IsPreferred: true,
          },
          {
            Id: 250,
            Name: 'Perry',
            IsPreferred: true,
          },
          {
            Id: 251,
            Name: 'Pickaway',
            IsPreferred: true,
          },
          {
            Id: 252,
            Name: 'Pike',
            IsPreferred: true,
          },
          {
            Id: 253,
            Name: 'Ross',
            IsPreferred: true,
          },
          {
            Id: 254,
            Name: 'Scioto',
            IsPreferred: true,
          },
          {
            Id: 255,
            Name: 'Vinton',
            IsPreferred: true,
          },
        ],
        Id: 21,
        Name: 'OH',
      },
      {
        Counties: [
          {
            Id: 797,
            Name: 'Mason',
            IsPreferred: true,
          },
          {
            Id: 798,
            Name: 'Cabell',
            IsPreferred: true,
          },
          {
            Id: 799,
            Name: 'Wayne',
            IsPreferred: true,
          },
        ],
        Id: 29,
        Name: 'WV',
      },
    ],
    Zip: '43137',
  },
  {
    Address: '182 West Hamlin Rd.',
    City: 'Benson',
    Id: 9,
    Name: 'Raleigh-Durham',
    State: 'NC',
    States: [
      {
        Counties: [
          {
            Id: 563,
            Name: 'Chatham',
            IsPreferred: true,
          },
          {
            Id: 564,
            Name: 'Cumberland',
            IsPreferred: true,
          },
          {
            Id: 569,
            Name: 'Durham',
            IsPreferred: true,
          },
          {
            Id: 570,
            Name: 'Edgecombe',
            IsPreferred: true,
          },
          {
            Id: 572,
            Name: 'Franklin',
            IsPreferred: true,
          },
          {
            Id: 573,
            Name: 'Granville',
            IsPreferred: true,
          },
          {
            Id: 574,
            Name: 'Greene',
            IsPreferred: true,
          },
          {
            Id: 575,
            Name: 'Halifax',
            IsPreferred: true,
          },
          {
            Id: 576,
            Name: 'Harnett',
            IsPreferred: true,
          },
          {
            Id: 578,
            Name: 'Hoke',
            IsPreferred: true,
          },
          {
            Id: 579,
            Name: 'Johnston',
            IsPreferred: true,
          },
          {
            Id: 580,
            Name: 'Lee',
            IsPreferred: true,
          },
          {
            Id: 581,
            Name: 'Lenoir',
            IsPreferred: true,
          },
          {
            Id: 582,
            Name: 'Martin',
            IsPreferred: true,
          },
          {
            Id: 583,
            Name: 'Nash',
            IsPreferred: true,
          },
          {
            Id: 584,
            Name: 'Northampton',
            IsPreferred: true,
          },
          {
            Id: 585,
            Name: 'Orange',
            IsPreferred: true,
          },
          {
            Id: 586,
            Name: 'Person',
            IsPreferred: true,
          },
          {
            Id: 587,
            Name: 'Pitt',
            IsPreferred: true,
          },
          {
            Id: 588,
            Name: 'Sampson',
            IsPreferred: true,
          },
          {
            Id: 589,
            Name: 'Vance',
            IsPreferred: true,
          },
          {
            Id: 590,
            Name: 'Wake',
            IsPreferred: true,
          },
          {
            Id: 591,
            Name: 'Warren',
            IsPreferred: true,
          },
          {
            Id: 592,
            Name: 'Wayne',
            IsPreferred: true,
          },
          {
            Id: 593,
            Name: 'Wilson',
            IsPreferred: true,
          },
        ],
        Id: 49,
        Name: 'NC',
      },
    ],
    Zip: '27504',
  },
  {
    Address: '341 Alcove Road',
    City: 'Mooresville',
    Id: 10,
    Name: 'Charlotte',
    State: 'NC',
    States: [
      {
        Counties: [
          {
            Id: 78,
            Name: 'Alexander',
            IsPreferred: true,
          },
          {
            Id: 79,
            Name: 'Anson',
            IsPreferred: true,
          },
          {
            Id: 80,
            Name: 'Burke',
            IsPreferred: true,
          },
          {
            Id: 81,
            Name: 'Cabarrus',
            IsPreferred: true,
          },
          {
            Id: 82,
            Name: 'Caldwell',
            IsPreferred: true,
          },
          {
            Id: 83,
            Name: 'Catawba',
            IsPreferred: true,
          },
          {
            Id: 85,
            Name: 'Cleveland',
            IsPreferred: true,
          },
          {
            Id: 91,
            Name: 'Gaston',
            IsPreferred: true,
          },
          {
            Id: 94,
            Name: 'Iredell',
            IsPreferred: true,
          },
          {
            Id: 96,
            Name: 'Lincoln',
            IsPreferred: true,
          },
          {
            Id: 97,
            Name: 'Mecklenburg',
            IsPreferred: true,
          },
          {
            Id: 103,
            Name: 'Rowan',
            IsPreferred: true,
          },
          {
            Id: 105,
            Name: 'Stanly',
            IsPreferred: true,
          },
          {
            Id: 106,
            Name: 'Union',
            IsPreferred: true,
          },
        ],
        Id: 9,
        Name: 'NC',
      },
      {
        Counties: [
          {
            Id: 547,
            Name: 'Chesterfield',
            IsPreferred: false,
          },
          {
            Id: 548,
            Name: 'Lancaster',
            IsPreferred: false,
          },
          {
            Id: 549,
            Name: 'York',
            IsPreferred: true,
          },
        ],
        Id: 46,
        Name: 'SC',
      },
    ],
    Zip: '28117',
  },
  {
    Address: '6349 Burnt Poplar Rd.',
    City: 'Greensboro',
    Id: 11,
    Name: 'Greensboro/Winston',
    State: 'NC',
    States: [
      {
        Counties: [
          {
            Id: 385,
            Name: 'Alamance',
            IsPreferred: false,
          },
          {
            Id: 386,
            Name: 'Alleghany',
            IsPreferred: false,
          },
          {
            Id: 388,
            Name: 'Caswell',
            IsPreferred: false,
          },
          {
            Id: 390,
            Name: 'Davidson',
            IsPreferred: false,
          },
          {
            Id: 391,
            Name: 'Davie',
            IsPreferred: false,
          },
          {
            Id: 397,
            Name: 'Forsyth',
            IsPreferred: false,
          },
          {
            Id: 400,
            Name: 'Guilford',
            IsPreferred: false,
          },
          {
            Id: 403,
            Name: 'Montgomery',
            IsPreferred: false,
          },
          {
            Id: 404,
            Name: 'Moore',
            IsPreferred: false,
          },
          {
            Id: 409,
            Name: 'Randolph',
            IsPreferred: false,
          },
          {
            Id: 410,
            Name: 'Rockingham',
            IsPreferred: false,
          },
          {
            Id: 411,
            Name: 'Stokes',
            IsPreferred: false,
          },
          {
            Id: 412,
            Name: 'Surry',
            IsPreferred: false,
          },
          {
            Id: 416,
            Name: 'Wilkes',
            IsPreferred: false,
          },
          {
            Id: 417,
            Name: 'Yadkin',
            IsPreferred: false,
          },
        ],
        Id: 34,
        Name: 'NC',
      },
      {
        Counties: [
          {
            Id: 603,
            Name: 'Carroll',
            IsPreferred: false,
          },
          {
            Id: 606,
            Name: 'Henry',
            IsPreferred: false,
          },
          {
            Id: 607,
            Name: 'Patrick',
            IsPreferred: false,
          },
        ],
        Id: 52,
        Name: 'VA',
      },
    ],
    Zip: '27409',
  },
  {
    Address: '10 Edgewood Lane NE',
    City: 'Winnabow',
    Id: 12,
    Name: 'Wilmington',
    State: 'NC',
    States: [
      {
        Counties: [
          {
            Id: 112,
            Name: 'Bladen',
            IsPreferred: true,
          },
          {
            Id: 113,
            Name: 'Brunswick',
            IsPreferred: true,
          },
          {
            Id: 114,
            Name: 'Columbus',
            IsPreferred: true,
          },
          {
            Id: 115,
            Name: 'Craven',
            IsPreferred: true,
          },
          {
            Id: 121,
            Name: 'Duplin',
            IsPreferred: true,
          },
          {
            Id: 123,
            Name: 'Jones',
            IsPreferred: true,
          },
          {
            Id: 125,
            Name: 'New Hanover',
            IsPreferred: true,
          },
          {
            Id: 126,
            Name: 'Onslow',
            IsPreferred: true,
          },
          {
            Id: 127,
            Name: 'Pender',
            IsPreferred: true,
          },
          {
            Id: 128,
            Name: 'Robeson',
            IsPreferred: true,
          },
          {
            Id: 691,
            Name: 'Scotland',
            IsPreferred: true,
          },
          {
            Id: 763,
            Name: 'Beaufort',
            IsPreferred: false,
          },
          {
            Id: 813,
            Name: 'Carteret',
            IsPreferred: false,
          },
          {
            Id: 814,
            Name: 'Pamlico',
            IsPreferred: false,
          },
        ],
        Id: 13,
        Name: 'NC',
      },
      {
        Counties: [
          {
            Id: 599,
            Name: 'Dillon',
            IsPreferred: true,
          },
          {
            Id: 600,
            Name: 'Horry',
            IsPreferred: true,
          },
          {
            Id: 601,
            Name: 'Marion',
            IsPreferred: true,
          },
        ],
        Id: 51,
        Name: 'SC',
      },
    ],
    Zip: '28479',
  },
  {
    Address: '271 Treeland Dr.',
    City: 'Ladson',
    Id: 13,
    Name: 'Charleston',
    State: 'SC',
    States: [
      {
        Counties: [
          {
            Id: 53,
            Name: 'Berkeley',
            IsPreferred: true,
          },
          {
            Id: 54,
            Name: 'Charleston',
            IsPreferred: true,
          },
          {
            Id: 56,
            Name: 'Georgetown',
            IsPreferred: true,
          },
          {
            Id: 643,
            Name: 'Colleton',
            IsPreferred: true,
          },
          {
            Id: 644,
            Name: 'Dorchester',
            IsPreferred: true,
          },
          {
            Id: 645,
            Name: 'Williamsburg',
            IsPreferred: true,
          },
        ],
        Id: 6,
        Name: 'SC',
      },
    ],
    Zip: '29456',
  },
  {
    Address: '341 Inglesby Parkway',
    City: 'Duncan',
    Id: 14,
    Name: 'Greenville/Spartanburg',
    State: 'SC',
    States: [
      {
        Counties: [
          {
            Id: 357,
            Name: 'Cherokee',
            IsPreferred: true,
          },
          {
            Id: 358,
            Name: 'Chester',
            IsPreferred: true,
          },
          {
            Id: 359,
            Name: 'Greenville',
            IsPreferred: true,
          },
          {
            Id: 360,
            Name: 'McCormick',
            IsPreferred: true,
          },
          {
            Id: 361,
            Name: 'Newberry',
            IsPreferred: false,
          },
          {
            Id: 646,
            Name: 'Abbeville',
            IsPreferred: true,
          },
          {
            Id: 647,
            Name: 'Anderson',
            IsPreferred: true,
          },
          {
            Id: 648,
            Name: 'Greenwood',
            IsPreferred: true,
          },
          {
            Id: 649,
            Name: 'Laurens',
            IsPreferred: true,
          },
          {
            Id: 650,
            Name: 'Oconee',
            IsPreferred: true,
          },
          {
            Id: 651,
            Name: 'Pickens',
            IsPreferred: true,
          },
          {
            Id: 652,
            Name: 'Spartanburg',
            IsPreferred: true,
          },
          {
            Id: 653,
            Name: 'Union',
            IsPreferred: true,
          },
        ],
        Id: 31,
        Name: 'SC',
      },
    ],
    Zip: '29334',
  },
  {
    Address: '743 Jacobs Mill Pond Rd.',
    City: 'Elgin',
    Id: 15,
    Name: 'Columbia',
    State: 'SC',
    States: [
      {
        Counties: [
          {
            Id: 285,
            Name: 'Aiken',
            IsPreferred: true,
          },
          {
            Id: 286,
            Name: 'Bamberg',
            IsPreferred: true,
          },
          {
            Id: 287,
            Name: 'Barnwell',
            IsPreferred: true,
          },
          {
            Id: 288,
            Name: 'Calhoun',
            IsPreferred: true,
          },
          {
            Id: 289,
            Name: 'Chester',
            IsPreferred: false,
          },
          {
            Id: 290,
            Name: 'Chesterfield',
            IsPreferred: true,
          },
          {
            Id: 291,
            Name: 'Clarendon',
            IsPreferred: true,
          },
          {
            Id: 292,
            Name: 'Darlington',
            IsPreferred: true,
          },
          {
            Id: 293,
            Name: 'Edgefield',
            IsPreferred: true,
          },
          {
            Id: 294,
            Name: 'Fairfield',
            IsPreferred: true,
          },
          {
            Id: 295,
            Name: 'Florence',
            IsPreferred: true,
          },
          {
            Id: 296,
            Name: 'Kershaw',
            IsPreferred: true,
          },
          {
            Id: 297,
            Name: 'Lancaster',
            IsPreferred: true,
          },
          {
            Id: 298,
            Name: 'Lee',
            IsPreferred: true,
          },
          {
            Id: 299,
            Name: 'Lexington',
            IsPreferred: true,
          },
          {
            Id: 300,
            Name: 'Marlboro',
            IsPreferred: true,
          },
          {
            Id: 301,
            Name: 'Newberry',
            IsPreferred: true,
          },
          {
            Id: 302,
            Name: 'Orangeburg',
            IsPreferred: true,
          },
          {
            Id: 303,
            Name: 'Richland',
            IsPreferred: true,
          },
          {
            Id: 304,
            Name: 'Saluda',
            IsPreferred: true,
          },
          {
            Id: 305,
            Name: 'Sumter',
            IsPreferred: true,
          },
        ],
        Id: 25,
        Name: 'SC',
      },
    ],
    Zip: '29045',
  },
  {
    Address: '500 Greengate Centre Circle',
    City: 'Greensburg',
    Id: 16,
    Name: 'Greensburg',
    State: 'PA',
    States: [
      {
        Counties: [
          {
            Id: 623,
            Name: 'Allegheny',
            IsPreferred: true,
          },
          {
            Id: 624,
            Name: 'Armstrong',
            IsPreferred: true,
          },
          {
            Id: 627,
            Name: 'Butler',
            IsPreferred: true,
          },
          {
            Id: 628,
            Name: 'Cambria',
            IsPreferred: true,
          },
          {
            Id: 630,
            Name: 'Clearfield',
            IsPreferred: true,
          },
          {
            Id: 631,
            Name: 'Fayette',
            IsPreferred: true,
          },
          {
            Id: 632,
            Name: 'Greene',
            IsPreferred: true,
          },
          {
            Id: 634,
            Name: 'Indiana',
            IsPreferred: true,
          },
          {
            Id: 635,
            Name: 'Jefferson',
            IsPreferred: true,
          },
          {
            Id: 636,
            Name: 'Somerset',
            IsPreferred: true,
          },
          {
            Id: 637,
            Name: 'Washington',
            IsPreferred: true,
          },
          {
            Id: 638,
            Name: 'Westmoreland',
            IsPreferred: true,
          },
        ],
        Id: 54,
        Name: 'PA',
      },
    ],
    Zip: '15601',
  },
  {
    Address: '798 Dogwood Rd',
    City: 'Asheville',
    Id: 18,
    Name: 'Asheville',
    State: 'NC',
    States: [
      {
        Counties: [
          {
            Id: 148,
            Name: 'Buncombe',
            IsPreferred: true,
          },
          {
            Id: 160,
            Name: 'Haywood',
            IsPreferred: true,
          },
          {
            Id: 161,
            Name: 'Henderson',
            IsPreferred: true,
          },
          {
            Id: 165,
            Name: 'Madison',
            IsPreferred: true,
          },
          {
            Id: 166,
            Name: 'McDowell',
            IsPreferred: true,
          },
          {
            Id: 167,
            Name: 'Mitchell',
            IsPreferred: true,
          },
          {
            Id: 172,
            Name: 'Polk',
            IsPreferred: true,
          },
          {
            Id: 173,
            Name: 'Rutherford',
            IsPreferred: true,
          },
          {
            Id: 175,
            Name: 'Transylvania',
            IsPreferred: true,
          },
          {
            Id: 180,
            Name: 'Yancey',
            IsPreferred: true,
          },
        ],
        Id: 16,
        Name: 'NC',
      },
    ],
    Zip: '28806',
  },
  {
    Address: '27735 James Chapel Rd.',
    City: 'Holden',
    Id: 20,
    Name: 'Baton Rouge/New Orleans',
    State: 'LA',
    States: [
      {
        Counties: [
          {
            Id: 30,
            Name: 'Adams',
            IsPreferred: true,
          },
          {
            Id: 31,
            Name: 'Amite',
            IsPreferred: true,
          },
          {
            Id: 41,
            Name: 'Pike',
            IsPreferred: true,
          },
          {
            Id: 42,
            Name: 'Wilkinson',
            IsPreferred: true,
          },
          {
            Id: 769,
            Name: 'Walthall',
            IsPreferred: true,
          },
        ],
        Id: 4,
        Name: 'MS',
      },
      {
        Counties: [
          {
            Id: 261,
            Name: 'Ascension',
            IsPreferred: true,
          },
          {
            Id: 262,
            Name: 'Assumption',
            IsPreferred: true,
          },
          {
            Id: 265,
            Name: 'East Baton Rouge',
            IsPreferred: true,
          },
          {
            Id: 266,
            Name: 'East Feliciana',
            IsPreferred: true,
          },
          {
            Id: 267,
            Name: 'Iberville',
            IsPreferred: true,
          },
          {
            Id: 268,
            Name: 'Jefferson',
            IsPreferred: true,
          },
          {
            Id: 269,
            Name: 'Lafourche',
            IsPreferred: true,
          },
          {
            Id: 270,
            Name: 'Livingston',
            IsPreferred: true,
          },
          {
            Id: 271,
            Name: 'Orleans',
            IsPreferred: true,
          },
          {
            Id: 272,
            Name: 'Plaquemines',
            IsPreferred: true,
          },
          {
            Id: 273,
            Name: 'Pointe Coupee',
            IsPreferred: true,
          },
          {
            Id: 274,
            Name: 'St. Bernard',
            IsPreferred: true,
          },
          {
            Id: 275,
            Name: 'St. Charles',
            IsPreferred: true,
          },
          {
            Id: 276,
            Name: 'St. Helena',
            IsPreferred: true,
          },
          {
            Id: 277,
            Name: 'St. James',
            IsPreferred: true,
          },
          {
            Id: 278,
            Name: 'St. John The Baptist',
            IsPreferred: true,
          },
          {
            Id: 279,
            Name: 'St. Tammany',
            IsPreferred: true,
          },
          {
            Id: 280,
            Name: 'Tangipahoa',
            IsPreferred: true,
          },
          {
            Id: 281,
            Name: 'Terrebonne',
            IsPreferred: true,
          },
          {
            Id: 282,
            Name: 'Washington',
            IsPreferred: true,
          },
          {
            Id: 283,
            Name: 'West Baton Rouge',
            IsPreferred: true,
          },
          {
            Id: 284,
            Name: 'West Feliciana',
            IsPreferred: true,
          },
        ],
        Id: 24,
        Name: 'LA',
      },
    ],
    Zip: '70744',
  },
  {
    Address: '812 S Frontage Rd',
    City: 'Scott',
    Id: 21,
    Name: 'Lafayette',
    State: 'LA',
    States: [
      {
        Counties: [
          {
            Id: 323,
            Name: 'Acadia',
            IsPreferred: true,
          },
          {
            Id: 325,
            Name: 'Allen',
            IsPreferred: true,
          },
          {
            Id: 326,
            Name: 'Avoyelles',
            IsPreferred: true,
          },
          {
            Id: 327,
            Name: 'Beauregard',
            IsPreferred: true,
          },
          {
            Id: 328,
            Name: 'Calcasieu',
            IsPreferred: true,
          },
          {
            Id: 330,
            Name: 'Cameron',
            IsPreferred: true,
          },
          {
            Id: 331,
            Name: 'Evangeline',
            IsPreferred: true,
          },
          {
            Id: 332,
            Name: 'Iberia',
            IsPreferred: true,
          },
          {
            Id: 333,
            Name: 'Jefferson Davis',
            IsPreferred: true,
          },
          {
            Id: 335,
            Name: 'Lafayette',
            IsPreferred: true,
          },
          {
            Id: 337,
            Name: 'Rapides',
            IsPreferred: true,
          },
          {
            Id: 338,
            Name: 'St. Landry',
            IsPreferred: true,
          },
          {
            Id: 340,
            Name: 'St. Martin',
            IsPreferred: true,
          },
          {
            Id: 342,
            Name: 'St. Mary',
            IsPreferred: true,
          },
          {
            Id: 343,
            Name: 'Vermilion',
            IsPreferred: true,
          },
          {
            Id: 344,
            Name: 'Vernon',
            IsPreferred: true,
          },
        ],
        Id: 28,
        Name: 'LA',
      },
    ],
    Zip: '70583',
  },
  {
    Address: '41201 Bond Drive',
    City: 'Belmont',
    Id: 24,
    Name: 'Belmont',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 518,
            Name: 'Belmont',
            IsPreferred: true,
          },
          {
            Id: 519,
            Name: 'Harrison',
            IsPreferred: true,
          },
          {
            Id: 520,
            Name: 'Jefferson',
            IsPreferred: true,
          },
          {
            Id: 521,
            Name: 'Monroe',
            IsPreferred: true,
          },
          {
            Id: 695,
            Name: 'Guernsey',
            IsPreferred: true,
          },
          {
            Id: 707,
            Name: 'Noble',
            IsPreferred: true,
          },
          {
            Id: 708,
            Name: 'Washington',
            IsPreferred: true,
          },
        ],
        Id: 41,
        Name: 'OH',
      },
      {
        Counties: [
          {
            Id: 522,
            Name: 'Brooke',
            IsPreferred: true,
          },
          {
            Id: 523,
            Name: 'Hancock',
            IsPreferred: true,
          },
          {
            Id: 524,
            Name: 'Marshall',
            IsPreferred: true,
          },
          {
            Id: 525,
            Name: 'Ohio',
            IsPreferred: true,
          },
          {
            Id: 709,
            Name: 'Pleasants',
            IsPreferred: true,
          },
          {
            Id: 710,
            Name: 'Wood',
            IsPreferred: true,
          },
          {
            Id: 711,
            Name: 'Ritchie',
            IsPreferred: true,
          },
          {
            Id: 712,
            Name: 'Wirt',
            IsPreferred: true,
          },
          {
            Id: 713,
            Name: 'Tyler',
            IsPreferred: true,
          },
          {
            Id: 795,
            Name: 'Jackson',
            IsPreferred: true,
          },
          {
            Id: 796,
            Name: 'Roane',
            IsPreferred: true,
          },
        ],
        Id: 42,
        Name: 'WV',
      },
    ],
    Zip: '43718',
  },
  {
    Address: '121 Huntington Ridge Drive',
    City: 'Louisville',
    Id: 44,
    Name: 'Louisville',
    State: 'KY',
    States: [
      {
        Counties: [
          {
            Id: 674,
            Name: 'Oldham',
            IsPreferred: true,
          },
          {
            Id: 675,
            Name: 'Jefferson',
            IsPreferred: true,
          },
          {
            Id: 679,
            Name: 'Shelby',
            IsPreferred: true,
          },
          {
            Id: 680,
            Name: 'Spencer',
            IsPreferred: true,
          },
          {
            Id: 681,
            Name: 'Bullitt',
            IsPreferred: true,
          },
          {
            Id: 682,
            Name: 'Nelson',
            IsPreferred: true,
          },
          {
            Id: 765,
            Name: 'Hardin',
            IsPreferred: false,
          },
          {
            Id: 770,
            Name: 'Franklin',
            IsPreferred: false,
          },
        ],
        Id: 57,
        Name: 'KY',
      },
      {
        Counties: [
          {
            Id: 676,
            Name: 'Clark',
            IsPreferred: true,
          },
          {
            Id: 677,
            Name: 'Floyd',
            IsPreferred: true,
          },
          {
            Id: 678,
            Name: 'Harrison',
            IsPreferred: true,
          },
        ],
        Id: 58,
        Name: 'IN',
      },
    ],
    Zip: '40223',
  },
  {
    Address: '181 Angel Road',
    City: 'Franklin',
    Id: 45,
    Name: 'Franklin',
    State: 'NC',
    States: [
      {
        Counties: [
          {
            Id: 696,
            Name: 'Macon',
            IsPreferred: true,
          },
          {
            Id: 701,
            Name: 'Clay',
            IsPreferred: true,
          },
          {
            Id: 702,
            Name: 'Cherokee',
            IsPreferred: true,
          },
          {
            Id: 703,
            Name: 'Swain',
            IsPreferred: true,
          },
          {
            Id: 704,
            Name: 'Jackson',
            IsPreferred: true,
          },
          {
            Id: 705,
            Name: 'Graham',
            IsPreferred: true,
          },
        ],
        Id: 59,
        Name: 'NC',
      },
      {
        Counties: [
          {
            Id: 698,
            Name: 'Rabun',
            IsPreferred: true,
          },
          {
            Id: 699,
            Name: 'Towns',
            IsPreferred: true,
          },
          {
            Id: 700,
            Name: 'Union',
            IsPreferred: true,
          },
          {
            Id: 815,
            Name: 'Habersham',
            IsPreferred: false,
          },
        ],
        Id: 61,
        Name: 'GA',
      },
    ],
    Zip: '28734',
  },
  {
    Address: '1334 Frontage Road',
    City: 'Hardeeville',
    Id: 46,
    Name: 'Hilton Head/Savannah',
    State: 'SC',
    States: [
      {
        Counties: [
          {
            Id: 697,
            Name: 'Jasper',
            IsPreferred: true,
          },
          {
            Id: 723,
            Name: 'Allendale',
            IsPreferred: true,
          },
          {
            Id: 724,
            Name: 'Hampton',
            IsPreferred: true,
          },
          {
            Id: 725,
            Name: 'Beaufort',
            IsPreferred: true,
          },
        ],
        Id: 60,
        Name: 'SC',
      },
      {
        Counties: [
          {
            Id: 726,
            Name: 'Screven',
            IsPreferred: true,
          },
          {
            Id: 727,
            Name: 'Effingham',
            IsPreferred: true,
          },
          {
            Id: 728,
            Name: 'Chatham',
            IsPreferred: true,
          },
          {
            Id: 729,
            Name: 'Bulloch',
            IsPreferred: true,
          },
          {
            Id: 730,
            Name: 'Bryan',
            IsPreferred: true,
          },
          {
            Id: 756,
            Name: 'Liberty',
            IsPreferred: false,
          },
        ],
        Id: 63,
        Name: 'GA',
      },
    ],
    Zip: '29927',
  },
  {
    Address: '5221 Noggle Way',
    City: 'Indianapolis',
    Id: 47,
    Name: 'Indianapolis South',
    State: 'IN',
    States: [
      {
        Counties: [
          {
            Id: 716,
            Name: 'Marion',
            IsPreferred: true,
          },
          {
            Id: 717,
            Name: 'Shelby',
            IsPreferred: true,
          },
          {
            Id: 718,
            Name: 'Hancock',
            IsPreferred: true,
          },
          {
            Id: 719,
            Name: 'Johnson',
            IsPreferred: true,
          },
          {
            Id: 720,
            Name: 'Morgan',
            IsPreferred: true,
          },
          {
            Id: 721,
            Name: 'Hendricks',
            IsPreferred: true,
          },
          {
            Id: 722,
            Name: 'Boone',
            IsPreferred: true,
          },
          {
            Id: 731,
            Name: 'Hamilton',
            IsPreferred: true,
          },
          {
            Id: 732,
            Name: 'Madison',
            IsPreferred: true,
          },
          {
            Id: 757,
            Name: 'Rush',
            IsPreferred: false,
          },
          {
            Id: 758,
            Name: 'Decatur',
            IsPreferred: false,
          },
          {
            Id: 759,
            Name: 'Bartholomew',
            IsPreferred: false,
          },
          {
            Id: 760,
            Name: 'Brown',
            IsPreferred: false,
          },
          {
            Id: 761,
            Name: 'Monroe',
            IsPreferred: false,
          },
          {
            Id: 762,
            Name: 'Owen',
            IsPreferred: false,
          },
          {
            Id: 804,
            Name: 'Carroll',
            IsPreferred: false,
          },
          {
            Id: 805,
            Name: 'Tippecanoe',
            IsPreferred: false,
          },
          {
            Id: 806,
            Name: 'Montgomery',
            IsPreferred: false,
          },
          {
            Id: 807,
            Name: 'Putnam',
            IsPreferred: false,
          },
          {
            Id: 808,
            Name: 'Clinton',
            IsPreferred: false,
          },
          {
            Id: 809,
            Name: 'Tipton',
            IsPreferred: false,
          },
          {
            Id: 810,
            Name: 'Jackson',
            IsPreferred: false,
          },
          {
            Id: 811,
            Name: 'Jennings',
            IsPreferred: false,
          },
          {
            Id: 812,
            Name: 'Ripley',
            IsPreferred: false,
          },
        ],
        Id: 62,
        Name: 'IN',
      },
    ],
    Zip: '46237',
  },
  {
    Address: '1750 W Main St.',
    City: 'Dayton',
    Id: 48,
    Name: 'Dayton',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 733,
            Name: 'Mercer',
            IsPreferred: true,
          },
          {
            Id: 734,
            Name: 'Auglaize',
            IsPreferred: true,
          },
          {
            Id: 735,
            Name: 'Montgomery',
            IsPreferred: true,
          },
          {
            Id: 736,
            Name: 'Greene',
            IsPreferred: true,
          },
          {
            Id: 737,
            Name: 'Clark',
            IsPreferred: true,
          },
          {
            Id: 738,
            Name: 'Darke',
            IsPreferred: true,
          },
          {
            Id: 739,
            Name: 'Miami',
            IsPreferred: true,
          },
          {
            Id: 740,
            Name: 'Shelby',
            IsPreferred: true,
          },
          {
            Id: 741,
            Name: 'Logan',
            IsPreferred: true,
          },
          {
            Id: 742,
            Name: 'Champaign',
            IsPreferred: true,
          },
          {
            Id: 755,
            Name: 'Preble',
            IsPreferred: true,
          },
        ],
        Id: 64,
        Name: 'OH',
      },
      {
        Counties: [
          {
            Id: 766,
            Name: 'Jay',
            IsPreferred: true,
          },
          {
            Id: 767,
            Name: 'Wayne',
            IsPreferred: true,
          },
          {
            Id: 768,
            Name: 'Randolph',
            IsPreferred: true,
          },
          {
            Id: 800,
            Name: 'Henry',
            IsPreferred: true,
          },
          {
            Id: 801,
            Name: 'Delaware',
            IsPreferred: true,
          },
          {
            Id: 802,
            Name: 'Fayette',
            IsPreferred: true,
          },
          {
            Id: 803,
            Name: 'Union',
            IsPreferred: true,
          },
        ],
        Id: 66,
        Name: 'IN',
      },
    ],
    Zip: '45373',
  },
  {
    Address: '11015 Parkside Drive',
    City: 'Knoxville',
    Id: 49,
    Name: 'Knoxville',
    State: 'TN',
    States: [
      {
        Counties: [
          {
            Id: 744,
            Name: 'Grainger',
            IsPreferred: true,
          },
          {
            Id: 745,
            Name: 'Union',
            IsPreferred: true,
          },
          {
            Id: 746,
            Name: 'Anderson',
            IsPreferred: true,
          },
          {
            Id: 747,
            Name: 'Roane',
            IsPreferred: true,
          },
          {
            Id: 748,
            Name: 'Loudon',
            IsPreferred: true,
          },
          {
            Id: 749,
            Name: 'Blount',
            IsPreferred: true,
          },
          {
            Id: 750,
            Name: 'Sevier',
            IsPreferred: true,
          },
          {
            Id: 751,
            Name: 'Cocke',
            IsPreferred: true,
          },
          {
            Id: 752,
            Name: 'Hamblen',
            IsPreferred: true,
          },
          {
            Id: 753,
            Name: 'Jefferson',
            IsPreferred: true,
          },
          {
            Id: 754,
            Name: 'Knox',
            IsPreferred: true,
          },
          {
            Id: 788,
            Name: 'Monroe',
            IsPreferred: false,
          },
        ],
        Id: 65,
        Name: 'TN',
      },
    ],
    Zip: '37934',
  },
  {
    Address: '6539 South Dixie Highway',
    City: 'Cygnet',
    Id: 50,
    Name: 'Southeast Michigan',
    State: 'OH',
    States: [
      {
        Counties: [
          {
            Id: 771,
            Name: 'Hillsdale',
            IsPreferred: true,
          },
          {
            Id: 772,
            Name: 'Lenawee',
            IsPreferred: true,
          },
          {
            Id: 773,
            Name: 'Monroe',
            IsPreferred: true,
          },
        ],
        Id: 67,
        Name: 'MI',
      },
    ],
    Zip: '43413',
  },
  {
    Address: '812 S Frontage Rd',
    City: 'Scott',
    Id: 51,
    Name: 'Port Arthur',
    State: 'LA',
    States: [
      {
        Counties: [
          {
            Id: 774,
            Name: 'Newton',
            IsPreferred: true,
          },
          {
            Id: 775,
            Name: 'Jefferson',
            IsPreferred: true,
          },
          {
            Id: 776,
            Name: 'Orange',
            IsPreferred: true,
          },
        ],
        Id: 68,
        Name: 'TX',
      },
    ],
    Zip: '70583',
  },
  {
    Address: '',
    City: '',
    Id: 52,
    Name: 'Bay St. Louis/Gulfport',
    State: 'MS',
    States: [
      {
        Counties: [
          {
            Id: 780,
            Name: 'Pearl River',
            IsPreferred: true,
          },
          {
            Id: 781,
            Name: 'Hancock',
            IsPreferred: true,
          },
          {
            Id: 782,
            Name: 'Harrison',
            IsPreferred: true,
          },
          {
            Id: 783,
            Name: 'Stone',
            IsPreferred: true,
          },
        ],
        Id: 70,
        Name: 'MS',
      },
    ],
    Zip: '',
  },
  {
    Address: '',
    City: '',
    Id: 53,
    Name: 'State College',
    State: 'PA',
    States: [
      {
        Counties: [
          {
            Id: 784,
            Name: 'Centre',
            IsPreferred: true,
          },
          {
            Id: 785,
            Name: 'Huntingdon',
            IsPreferred: true,
          },
          {
            Id: 786,
            Name: 'Fulton',
            IsPreferred: true,
          },
        ],
        Id: 71,
        Name: 'PA',
      },
    ],
    Zip: '',
  },
  {
    Address: '275 Rutledge Ln',
    City: 'Lebanon',
    Id: 54,
    Name: 'Nashville',
    State: 'TN',
    States: [
      {
        Counties: [
          {
            Id: 823,
            Name: 'Wilson',
            IsPreferred: true,
          },
          {
            Id: 824,
            Name: 'Sumner',
            IsPreferred: true,
          },
          {
            Id: 825,
            Name: 'Robertson',
            IsPreferred: true,
          },
          {
            Id: 826,
            Name: 'Davidson',
            IsPreferred: true,
          },
          {
            Id: 827,
            Name: 'Williamson',
            IsPreferred: true,
          },
          {
            Id: 828,
            Name: 'Rutherford',
            IsPreferred: true,
          },
        ],
        Id: 74,
        Name: 'TN',
      },
    ],
    Zip: '37087',
  },
  {
    Address: '240 West Main Street',
    City: 'Charlottesville',
    Id: 55,
    Name: 'Charlottesville',
    State: 'VA',
    States: [],
    Zip: '22902',
  },
] as IDesignStudio[];
